import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { LaborDetailsViewModel } from '../../../business-entities/labor-details-view-model';
import { Features } from '../../../business-entities/user-role-view-model';
import { BrandType } from '../../../business-entities/vehicle-list-view-model';
import { BrandService } from '../../../business-services/brand.service';
import { LaborService } from '../../../business-services/labor.service';
import { CultureLocaleService } from '../../../services/culture-locale.service';
import { Subscription } from 'rxjs';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import * as fromEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-search-labor',
  templateUrl: './search-labor.component.html'
})
export class SearchLaborComponent implements OnInit {
  makeList: BrandType[] = [];
  allMakeList: BrandType[] =[];
  features: Features[] = [];
  brandCode: string;
  laborNumber: string = "";
  laborName: string = "";
  laborList: LaborDetailsViewModel[] = [];
  subscription : Subscription;

  @Input() companyMakeCode:string=null;
  constructor(
    private brandService: BrandService,
    private activeModal: NgbActiveModal,
    private toaster: ToastrService,
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    private laborService:LaborService,
    private cookieservice: CookieService,
    public cultureLocaleService: CultureLocaleService,
    private secureStorage: SecureStorage,
    private currentLanguageService: CurrentLanguage,
  ) { }

  ngOnInit(): void {
    this.GetAllMake();
    if(this.laborService.searchLabourNumber)
    {
      this.laborNumber=this.laborService.searchLabourNumber;
      this.onSearchLabor();
    }
  }

  async GetAllMake(): Promise<void> {
    let vehicleMakeCode=this.companyMakeCode ? this.companyMakeCode : "FELLES";
    await this.brandService.GetServiceBrandDropdownList(vehicleMakeCode).then(data => {
      if(data.responseObject?.errorCount)
      {
        this.makeList=[];
      }
      else
      {
        this.makeList = data.responseObject;
      }
    });
  }
  OnClose() {
   this.laborService.selectedLaborList = [];
    this.activeModal.dismiss(false);
  }

  async onSearchLabor(){
    if (this.empty(this.brandCode) && this.empty(this.laborName) && this.empty(this.laborNumber)) {
      this.laborList = [];
      let LaborNotFound = this.translate.instant("lblRequiredPartEntry");
      this.toaster.error(LaborNotFound);
      return;
    }
    this.spinner.show();
    let model = {
      makeCode: this.empty(this.brandCode) ? "" : this.brandCode,
      name: this.empty(this.laborName) ? "" : this.laborName,
      no: this.empty(this.laborNumber) ? "" : this.laborNumber,
      cultureCode: this.cookieservice.get('userSelectedLanguage'),
      dealerId:this.laborService.dealerId
    }
    await this.laborService.getSearchLabor(model).then(response => {
      this.laborList = this.LaborDataMapper(response?.responseObject);
      this.spinner.hide();
    }, _error => {
      this.spinner.hide();
    });
  }

  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  numberEmpty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
      case "0":
      case 0:
        return true;
      default:
        return false;
    }
  }
  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }
  isQtyPrice(event, value) {
    if (!this.cultureLocaleService.isQtyPrice(event, value)) {
      let msg = this.translate.instant("lblValidValue");
      this.toaster.error(msg)
      event.preventDefault();
    }
  }
  onSaveItems(){
    let record = this.laborList.filter(x => x.isLaborSelected);
    if (record.length == 0) {
      let ServiceNotFound = this.translate.instant("lblRequiredLaborSelect");
      this.toaster.error(ServiceNotFound);
      return;
    }
    this.spinner.show();
    this.laborService.selectedLaborList = [];
    for (let value of  record) {
      value.duration = this.numberEmpty(value.duration) ? 1 : value.duration;
      value.duration = Number(value.duration.toString().replace(',', '.'));
      if (this.laborService.selectedLaborList.findIndex(x => x.laborNo ==  value.laborNo) == -1){
        this.laborService.selectedLaborList.push(value);
      }
    }
    this.activeModal.dismiss(true);
  }

  private LaborDataMapper(service: LaborDetailsViewModel[]) {
    let supperArray = [];
    if (service && service.length > 0) {
      service.forEach(element=>{
        const single = Object();
        single.id = element.id;
        single.laborNo = element.laborNo;
        single.name = element.name;
        single.fixedPrice = element.fixedPrice;
        single.makeCode = element.makeCode;
        single.isLaborSelected = false;
        single.duration = element.duration;
        single.isFixed = element.isFixed;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

}
